export function sliceAndConnect(text, maxLength) {
  if (text) {
    if (text.length > maxLength) {
      const slicedText = text.slice(0, maxLength - 3) + "...";
      return slicedText;
    } else {
      return text;
    }
  } else {
    return "";
  }
}
